import { useEffect, useRef, useState } from "react";
import { Guid } from "../../../../api/baseApi";
import { getScheduledPriorityNestedPlayLists, ScheduledPriorityList } from "../../../../api/priorityListApi";
import { PriorityListSettings } from "./types";

export const useListSettings = (selectedPriorityLists: ScheduledPriorityList[]) => {
    const [listSettings, setListSettings] = useState<PriorityListSettings[]>([]);
    const settingsRef = useRef(listSettings);
    settingsRef.current = listSettings;

    useEffect(() => {
        (async () => {
            const newSettings: PriorityListSettings[] = [];
            for (const list of selectedPriorityLists) {
                const existing = settingsRef.current.find(s => s.listId === list.id);
                if (existing) {
                    newSettings.push(existing);
                    continue;
                }
                const result = await getScheduledPriorityNestedPlayLists(list.id);
                const nestedPlayLists = result.type === 'succes' ? result.data.items : [];
                newSettings.push({
                    listId: list.id,
                    listName: list.name,
                    nestedPlayLists,
                    includedTags: [],
                    excludedTags: [],
                    isUseOrRelationship: false,
                    isUseNestedPlaylist: false,
                    nestedPlaylistPeriod: 15,
                    selectedNestedPlaylist: null,
                    selectedPreRollPlaylist: null,
                    selectedPostRollPlaylist: null,
                });
            }
            setListSettings(newSettings);
        })();
    }, [selectedPriorityLists]);

    const updateListSettings = (listId: Guid, updates: Partial<PriorityListSettings>) => {
        setListSettings(prev => prev.map(s => s.listId === listId ? { ...s, ...updates } : s));
    };

    return { listSettings, updateListSettings };
};
